import React from 'react'
import {Modal, ModalTitle} from '../Modal'
import {styled} from 'styled-components'
import {Button} from '../../elements/Button'
import {LoaderIcon} from '../../elements/LoaderIcon'
import {CandidateElectionData} from '../../types/candidate'
import './CandidateConfirmModal.scss'

interface ICandidateModalProps {
  setConfirmModal: (open: boolean, errorMessage?: string) => void
  confirmModal: {
    open: boolean
    customTitle?: string
    customMessage?: string
  }
  handleSave: () => Promise<void>
  isLoading: boolean
  candidateName: string
  selectedAreas: CandidateElectionData
  requiredFields: Record<keyof typeof ErrorListItems, boolean>
  isAdmin: boolean
}

enum ErrorListItems {
  electionSelection = 'Vaalivalinta',
  municipalitySelection = 'Kuntavalinta',
  firstName = 'Kutsumanimi',
  birthday = 'Syntymäpäivä',
  image = 'Kuva',
  email = 'Sähköposti',
  terms = 'Tietosuojakuvauksen hyväksyminen'
}

const CandidateConfirmModal: React.FC<ICandidateModalProps> = ({
  setConfirmModal,
  confirmModal,
  handleSave,
  isLoading,
  candidateName,
  selectedAreas,
  requiredFields,
  isAdmin
}) => {
  const hasErrors = Object.values(requiredFields).some(r => !r)
  const {municipality = {}, county = {}} = selectedAreas
  const {open, customMessage, customTitle} = confirmModal

  return (
    <CustomModal isOpen={open} title={customTitle}>
      {(() => {
        switch (true) {
          case !!customMessage:
            return (
              <>
                <div className="candidate-confirm-modal__error">{customMessage}</div>
                <div className="candidate-confirm-modal__error-btn">
                  <Button onClick={() => setConfirmModal(false)} color="red">
                    Sulje
                  </Button>
                </div>
              </>
            )

          case hasErrors && !isAdmin:
            return (
              <>
                <ul className="candidate-confirm-modal__error-list">
                  {Object.entries(requiredFields).map(([key, value]) => {
                    return value ? null : <li key={key}>{ErrorListItems[key]}</li>
                  })}
                </ul>
                <div className="candidate-confirm-modal__error-btn">
                  <Button onClick={() => setConfirmModal(false)} color="red">
                    Sulje
                  </Button>
                </div>
              </>
            )

          default:
            return (
              <>
                <div className="candidate-confirm-modal__name">
                  Nimi vaalikoneessa: <span>{candidateName}</span>
                </div>
                <br />
                Olet ehdolla
                <ul className="candidate-confirm-modal__elections">
                  {!!Object.keys(municipality).length && (
                    <li>
                      Kuntavaaleissa kunnassa <span>{municipality.name}</span>
                    </li>
                  )}
                  {!!Object.keys(county).length && (
                    <li>
                      Aluevaaleissa alueella <span>{county.name}</span>
                    </li>
                  )}
                </ul>
                <div className="candidate-confirm-modal__buttons">
                  <Button onClick={() => setConfirmModal(false)} color="white">
                    MUOKKAA
                  </Button>
                  <Button onClick={handleSave}>
                    {isLoading && (
                      <span className="candidate-confirm-modal__loader">
                        <LoaderIcon />
                      </span>
                    )}
                    <div className={`candidate-confirm-modal__btn-text ${isLoading ? 'loading' : ''}`}>ALOITA VAALIKONE</div>
                  </Button>
                </div>
              </>
            )
        }
      })()}
    </CustomModal>
  )
}

export default CandidateConfirmModal

const CustomModal = styled(Modal)`
  ${ModalTitle} {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 0;
  }
`
